import { render, staticRenderFns } from "./mySelect.vue?vue&type=template&id=067301f3&scoped=true"
import script from "./mySelect.vue?vue&type=script&lang=js"
export * from "./mySelect.vue?vue&type=script&lang=js"
import style0 from "./mySelect.vue?vue&type=style&index=0&id=067301f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067301f3",
  null
  
)

export default component.exports